
/* styles */
require("!!vue-style-loader!css-loader!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-a06d34aa&scoped=true!sass-loader!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NotesList.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./NotesList.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-a06d34aa!./../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./NotesList.vue"),
  /* scopeId */
  "data-v-a06d34aa",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/NotesList.vue
// module id = 48
// module chunks = 0